import React from "react";
import { useTranslation } from "react-i18next";
import "../../src/i18n"; // Import i18n config

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div>
      <button onClick={() => changeLanguage("en")}>🇬🇧</button>
      <button onClick={() => changeLanguage("lv")}>🇱🇻</button>
    </div>
  );
};

export default LanguageSwitcher;
